module.exports = __webpack_public_path__ + "static/media/m2.1c295eb4.png";